import React from 'react';
import CustomPopup from '../CustomPopup';
import { IPPSubHeading } from '../../../library/Heading/Heading';
import Button from '../../../library/Button/button';

interface DeleteOwnerPopupProps {
  show: boolean;
  onClose: () => void;
  ownerName: string;
  assignedModulesCount: number;
  onConfirm: () => Promise<void>;
  submitting: boolean;
}

const DeleteOwnerPopup: React.FC<DeleteOwnerPopupProps> = ({
  show,
  onClose,
  ownerName,
  assignedModulesCount,
  onConfirm,
  submitting
}) => (
  <CustomPopup onClose={onClose} show={show} width="w-fit">
    <IPPSubHeading
      headerText={`Are you sure you want to Delete "${ownerName}"?`}
      className="text-lg font-medium mb-2"
    />
    {assignedModulesCount > 0 && (
      <p className="text-sm text-gray-600 mb-4 text-center">
        This owner currently has{' '}
        <span className="font-semibold text-black">{assignedModulesCount}</span>{' '}
        {assignedModulesCount === 1 ? 'module' : 'modules'} assigned. Deleting this owner will unassign{' '}
        {assignedModulesCount === 1 ? 'it' : 'them'}. Are you sure you want to proceed?
      </p>
    )}
    <div className="flex justify-center">
      <Button
        className="h-10 px-4 py-[1.75] bg-white hover:bg-black hover:text-white text-[#2c323f] rounded focus:outline-none border border-spacing-1 border-black mr-3"
        buttonText="Cancel"
        onclick={onClose}
      />
      <Button
        className="px-4 py-[1.75] bg-white hover:bg-red hover:text-white hover:border-red text-[#2c323f] rounded focus:outline-none border border-spacing-1 border-black ml-3"
        buttonText="Delete"
        onclick={onConfirm}
        loading={submitting}
        disabled={submitting}
      />
    </div>
  </CustomPopup>
);

export default React.memo(DeleteOwnerPopup);
